module.exports = __webpack_public_path__ + "static/media/logo.2cc85971.png";